import React, { useState, useEffect } from "react";
import "./UpdateExpenses.css";
import { API_URL, getImageUrl } from "./API";

const UpdateExpenses = ({ expense, onClose, onSubmit, projectId, projectName }) => {
  const [formData, setFormData] = useState({
    employeeId: '',
    employeeName: '',
    date: '',
    reason: '',
    amount: '',
    status: 'Pending',
    otherDetails: '',
    remarks: ''
  });
  
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImageUrl, setExistingImageUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [imageLoadError, setImageLoadError] = useState(false);

  const getUserRole = () => {
    const accessLevel = localStorage.getItem('accessLevel');
    const userRole = localStorage.getItem('currentUserRole') || '';
    
    if (accessLevel === 'full' || 
        userRole.toUpperCase() === 'CEO' || 
        userRole.toUpperCase().includes('CEO') ||
        userRole.toUpperCase() === 'ADMIN' ||
        userRole.toUpperCase().includes('ADMIN')) {
      return 'CEO';
    }
    return 'EMPLOYEE';
  };

  const isCEOOrAdmin = () => {
    return getUserRole() === 'CEO';
  };

  useEffect(() => {
    if (expense) {
     
      
      const empId = expense.employee_id || expense.employeeId || '';
      const empName = expense.employee_name || expense.employeeName || '';
      
      setFormData({
        employeeId: empId,
        employeeName: empName,
        date: expense.date || expense.date_of_expense || '',
        reason: expense.reason || expense.description || expense.expense_reason || '',
        amount: expense.amount || '',
        status: expense.status || 'Pending',
        otherDetails: expense.otherDetails || expense.other_details || '',
        remarks: expense.remarks || ''
      });

      const imagePath = expense.expense_image || 
                       expense.expenseImage || 
                       expense.image_url || 
                       expense.photo || 
                       expense.expense_image_path ||
                       expense.originalData?.expense_image ||
                       '';
      
  

      const imageUrl = getImageUrl(imagePath);
      
    

      if (imageUrl) {
        setExistingImageUrl(imageUrl);
        setPreviewUrl(imageUrl);
        setImageLoadError(false);
      } else {
     
        setExistingImageUrl('');
        setPreviewUrl('');
      }
    }
  }, [expense]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'application/pdf'];
      if (allowedTypes.includes(file.type)) {
        setSelectedFile(file);
        setError('');
        
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewUrl(reader.result);
          };
          reader.readAsDataURL(file);
        } else {
          setPreviewUrl('');
        }
      } else {
        setError('Invalid file type. Please select PNG, JPG, JPEG, GIF, or PDF files only.');
        setSelectedFile(null);
      }
    }
  };

  const handleDownloadImage = () => {
    if (existingImageUrl) {
     
      const link = document.createElement('a');
      link.href = existingImageUrl;
      link.download = `expense_${expense.id || 'image'}.${existingImageUrl.split('.').pop()}`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleImageError = (e) => {
   
    setImageLoadError(true);
  };

  const handleImageLoad = () => {
  
    setImageLoadError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isCEOOrAdmin()) {
      setError('You do not have permission to update expenses.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const formDataToSend = new FormData();
      
      const expenseId = expense.id || expense.expense_id || expense.pk || expense.primary_key;
      if (!expenseId) {
        setError('Expense ID not found. Cannot update expense.');
        setIsLoading(false);
        return;
      }

      if (!formData.employeeId) {
        setError('Employee ID is required.');
        setIsLoading(false);
        return;
      }

      formDataToSend.append('expense_id', expenseId);
      formDataToSend.append('project_id', projectId);
      formDataToSend.append('employee_id', formData.employeeId);
      formDataToSend.append('expense_reason', formData.reason);
      formDataToSend.append('amount', formData.amount);
      formDataToSend.append('status', formData.status);
      formDataToSend.append('date_of_expense', formData.date);
      formDataToSend.append('other_details', formData.otherDetails || '');
      formDataToSend.append('remarks', formData.remarks || '');

      const response = await fetch(`${API_URL}/projects/create_update_project_expense`, {
        method: 'PUT',
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        if (formData.status === 'Approved' || formData.status === 'Rejected') {
          const currentUserId = localStorage.getItem('currentUserId');
          const currentUserName = localStorage.getItem('currentUserName');
          
          const notification = {
            id: Date.now(),
            type: formData.status === 'Approved' ? 'expense_approved' : 'expense_rejected',
            message: `Your expense of ₹${formData.amount} for "${formData.reason}" has been ${formData.status.toLowerCase()}`,
            details: {
              approver: currentUserName,
              amount: formData.amount,
              reason: formData.reason,
              remarks: formData.remarks
            },
            timestamp: new Date().toISOString(),
            read: false
          };

          const existingNotifications = JSON.parse(
            localStorage.getItem(`notifications_${formData.employeeId}`) || '[]'
          );
          existingNotifications.unshift(notification);
          
          localStorage.setItem(
            `notifications_${formData.employeeId}`,
            JSON.stringify(existingNotifications)
          );
          
          window.dispatchEvent(new Event('notificationUpdate'));
        }

        const updatedExpenseData = {
          ...expense,
          status: formData.status,
          remarks: formData.remarks
        };

        onSubmit(updatedExpenseData);
        alert('Expense updated successfully!');
        onClose();
      } else {
        setError(result.message || 'Failed to update expense');
      }
    } catch (error) {
  
      setError('Network error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const isFieldDisabled = !isCEOOrAdmin();

  return (
    <div className="UPEE-00">
      <div className="UPEE-01">
        <div className="UPEE-02">
          <h2>Update Expense</h2>
          <button className="UPEE-03" onClick={handleCancel}>×</button>
        </div>

        <div className="UPEE-04">
          {error && <div className="UPEE-05">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="UPEE-06">
              <div className="UPEE-07">
                <label htmlFor="employeeId">Employee ID:</label>
                <input
                  type="number"
                  id="employeeId"
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                  }}
                />
              </div>

              <div className="UPEE-07">
                <label htmlFor="employeeName">Employee Name:</label>
                <input
                  type="text"
                  id="employeeName"
                  name="employeeName"
                  value={formData.employeeName}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                  }}
                />
              </div>
            </div>

            <div className="UPEE-06">
              <div className="UPEE-07">
                <label htmlFor="date">Date:</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  }}
                />
              </div>

              <div className="UPEE-07">
                <label htmlFor="amount">Amount (₹):</label>
                <input
                  type="number"
                  id="amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  step="0.01"
                  min="0"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  }}
                />
              </div>
            </div>

            <div className="UPEE-06">
              <div className="UPEE-07">
                <label htmlFor="reason">Reason:</label>
                <textarea
                  id="reason"
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  }}
                />
              </div>

              <div className="UPEE-07">
                <label htmlFor="status">
                  Status {isCEOOrAdmin() && <span style={{ color: 'red' }}></span>}
                </label>
                {isCEOOrAdmin() ? (
                  <select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    className="UPEE-08"
                  >
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                ) : (
                  <input
                    type="text"
                    id="status"
                    name="status"
                    value={formData.status}
                    className="UPEE-08"
                    readOnly
                    style={{
                      backgroundColor: '#f5f5f5',
                      cursor: 'not-allowed',
                      color: '#666'
                    }}
                  />
                )}
              </div>
            </div>

            <div className="UPEE-06">
              <div className="UPEE-07">
                <label htmlFor="otherDetails">Other Details:</label>
                <textarea
                  id="otherDetails"
                  name="otherDetails"
                  value={formData.otherDetails}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  }}
                />
              </div>

              <div className="UPEE-07">
                <label htmlFor="remarks">Remarks:</label>
                <textarea
                  id="remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleInputChange}
                  className="UPEE-08"
                  placeholder={isCEOOrAdmin() ? "Enter remarks here..." : ""}
                  readOnly={!isCEOOrAdmin()}
                  style={!isCEOOrAdmin() ? {
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  } : {}}
                />
              </div>
            </div>

            <div className="UPEE-06">
              <div className="UPEE-07">
                <label htmlFor="expenseImage">Expense Image:</label>
                <input
                  type="file"
                  id="expenseImage"
                  name="expenseImage"
                  onChange={handleFileChange}
                  className="UPEE-08 UPEE-09"
                  accept=".png,.jpg,.jpeg,.gif,.pdf"
                  disabled
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                  }}
                />
                <small className="UPEE-10">
                  Image cannot be updated
                </small>
              </div>
            </div>

            {previewUrl && (
              <div className="UPEE-14">
                <label>Current Expense Image:</label>
                <div className="UPEE-15">
                  {!imageLoadError ? (
                    <img
                      src={previewUrl}
                      alt="Expense"
                      style={{ 
                        width: "200px", 
                        height: "200px", 
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                        backgroundColor: "#f9f9f9"
                      }}
                      onError={handleImageError}
                      onLoad={handleImageLoad}
                    />
                  ) : (
                    <div style={{
                      width: "200px",
                      height: "200px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f9f9f9",
                      color: "#999",
                      flexDirection: "column"
                    }}>
                      <p>Image not available</p>
                      <small style={{ fontSize: "10px", marginTop: "5px" }}>
                        {previewUrl}
                      </small>
                    </div>
                  )}
                  
                  {existingImageUrl && !imageLoadError && (
                    <button
                      type="button"
                      onClick={handleDownloadImage}
                      className="UPEE-16"
                      style={{ marginTop: "10px" }}
                    >
                      View Image
                    </button>
                  )}
                </div>
              </div>
            )}

            <div className="UPEE-11">
              <button
                type="button"
                onClick={handleCancel}
                className="UPEE-12"
                disabled={isLoading}
              >
                Cancel
              </button>
              {isCEOOrAdmin() && (
                <button
                  type="submit"
                  className="UPEE-13"
                  disabled={isLoading}
                >
                  {isLoading ? 'Updating...' : 'Update Expense'}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateExpenses;